export default "__VITE_ASSET__9d60f350__"